import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getCookie } from '@chilecompra/react-kit'

import BrandLayout from '../../components/Layouts/BrandLayout'
import ProtectByProfile from '../../components/Security/ProtectByProfile'
import ProtectByStep from '../../components/Security/ProtectByStep'
import NotFound from '../NotFound/NotFound'
import DirectDealSearch from '../DirectDealSearch/DirectDealSearch'

import routes from '../../config/settings/routes'
import { initializeReCaptcha } from '../../modules/hooks/reCaptcha'
import { PROTECT_BY_STEP_DICTIONARY } from '../../config/settings/constants'

import AuthorizationContext from '../../containers/AuthProvider/AuthProvider.context'
import AuthorizationProviderContainer from '../../containers/AuthProvider/AuthProvider.container'
import DirectDealPageHeader from '../../containers/DirectDealPageHeader/DirectDealPageHeader.container'
import DirectDealVoucherContainer from '../../containers/DirectDealVoucher/DirectDealVoucher.container'

import { Grid } from './DirectDealVoucher.styles'

/**
 * The DirectDealStepVoucher's page.
 */
const DirectDealVoucher = () => {
  const navigate = useNavigate()

  const directDealheading = {
    breadcrumbs: [
      {
        text: 'Escritorio',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Trato Directo',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Crear Trato Directo'
      }
    ],
    showHeaderNotifications: false
  }

  return (
    <AuthorizationProviderContainer>
      <AuthorizationContext.Consumer>
        {({ isPrivated }) => {
          if (isPrivated) initializeReCaptcha()
          return (
            <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => <NotFound />}>
              <ProtectByStep step={PROTECT_BY_STEP_DICTIONARY.VOUCHER} fallback={() => <DirectDealSearch />}>
                <BrandLayout featured={<DirectDealPageHeader {...directDealheading} />}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <DirectDealVoucherContainer />
                    </Grid>
                  </Grid>
                </BrandLayout>
              </ProtectByStep>
            </ProtectByProfile>
          )
        }}
      </AuthorizationContext.Consumer>
    </AuthorizationProviderContainer>
  )
}

export default DirectDealVoucher
